import { render } from "./HandlingProjects.vue?vue&type=template&id=003de7ec"
import script from "./HandlingProjects.vue?vue&type=script&lang=js"
export * from "./HandlingProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__